import React, { useEffect, useRef } from 'react';
import theme, { getTheme } from '../../theme';
import { useDarkMode } from '../../context/DarkModeContext';

export default function Modal({ open, onClose, title, children, maxWidth = '480px' }) {
  const closeRef = useRef(null);
  const { isDark } = useDarkMode();
  const t = getTheme(isDark);

  useEffect(() => {
    if (!open) return;
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  if (!open) return null;

  const titleId = title ? 'modal-title' : undefined;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        background: 'rgba(0,0,0,0.75)',
        backdropFilter: 'blur(12px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 20,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: t.surface2,
          border: `1px solid ${t.border2}`,
          borderRadius: theme.r4,
          boxShadow: t.shadow3,
          width: '100%',
          maxWidth,
          maxHeight: '90vh',
          overflowY: 'auto',
          padding: 28,
          animation: 'fadeInScale 0.2s ease',
        }}
      >
        {title && (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
            <h2 id={titleId} style={{ fontSize: 18, fontWeight: 700, color: t.text, margin: 0, fontFamily: theme.fontDisplay }}>{title}</h2>
            <button
              ref={closeRef}
              onClick={onClose}
              aria-label="Close dialog"
              style={{ background: t.border, border: 'none', fontSize: '18px', color: t.textTert, cursor: 'pointer', lineHeight: 1, width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 8, transition: 'all 0.15s' }}
              onMouseEnter={e => { e.currentTarget.style.background = t.surface3; e.currentTarget.style.color = t.text; }}
              onMouseLeave={e => { e.currentTarget.style.background = t.border; e.currentTarget.style.color = t.textTert; }}
            >×</button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
